import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initProcessSteps() {
  document.querySelectorAll(".process-steps").forEach((block) => {
    initDesktopScrollAnimation(block as HTMLElement);
  });
}

function initDesktopScrollAnimation(block: HTMLElement) {
  if (window.innerWidth < 768) return;

  const container = block.querySelector(".container") as HTMLElement;
  const track = block.querySelector(".process-steps__track") as HTMLElement;

  if (!container || !track) return;

  const stepCount = parseInt(track.dataset.stepCount || "0");
  if (stepCount === 0) return;

  const containerWidth = container.clientWidth;
  const trackWidth = track.scrollWidth;
  const scrollDistance = Math.max(0, trackWidth - containerWidth);

  if (scrollDistance <= 0) return;

  const header = document.querySelector("header");
  const headerHeight = header ? header.offsetHeight : 52;
  const isEditor = document.body.classList.contains("block-editor-page");

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: block,
      start: `top ${headerHeight}px`,
      end: () => `+=${scrollDistance}`,
      pin: !isEditor,
      scrub: isEditor ? false : 1,
      anticipatePin: !isEditor ? 1 : 0,
      invalidateOnRefresh: true,
    },
  });

  tl.to(track, {
    x: -scrollDistance,
    ease: "none",
  });
}

function handleResize() {
  ScrollTrigger.getAll().forEach((trigger) => {
    if (
      trigger.vars.trigger &&
      trigger.vars.trigger.closest(".process-steps")
    ) {
      trigger.kill();
    }
  });

  initProcessSteps();
}

document.addEventListener("DOMContentLoaded", () => {
  initProcessSteps();

  let resizeTimer: number;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(handleResize, 250);
  });
});

if (window.wp && window.wp.domReady) {
  window.wp.domReady(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          const addedNodes = Array.from(mutation.addedNodes);
          const hasProcessSteps = addedNodes.some(
            (node: any) =>
              node.nodeType === 1 &&
              node.querySelector &&
              node.querySelector(".process-steps"),
          );

          if (hasProcessSteps) {
            setTimeout(initProcessSteps, 100);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

